export default "__VITE_ASSET__Ktq0q$Ph__"